module.exports = __webpack_public_path__ + "static/media/icon-award2.ee562954.svg";